<template>
  <el-card class="box-card-large">
    <div slot="header" class="clearfix">
      <span>{{ $t('api.default.soaItems' )}}</span>
    </div>
    <el-form-item
      :prop="prop"
    >
      <el-row
        :gutter="10"
        v-for="(itemData, idx) in item"
        :key="idx"
      >
        <el-col :xs="24" :md="4">
          <std-opt
            v-model="itemData.product_type"
            name="itemProductType"
            :hasLabel="idx === 0"
            @input="resetServiceType(idx)"
          >
          </std-opt>
        </el-col>
        <el-col :xs="24" :md="5">
          <std-opt
            v-model="itemData.service_type"
            name="itemServiceType"
            :hiddenValue="getHiddenServiceTypes(itemData.product_type)"
            :hasLabel="idx === 0"
          >
          </std-opt>
        </el-col>
        <el-col :xs="24" :md="4">
          <text-field
            v-model.number="itemData.amount"
            :base="itemBase"
            name="amount"
            type="number"
            dataType="price"
            :prop="`item.${idx}.amount`"
            :min="0"
            :precision="currencyPrecision"
            :clearable="false"
            :hasLabel="idx === 0"
            required
          >
            <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            v-model="itemData.description"
            :base="itemBase"
            name="description"
            maxlength="128"
            :hasLabel="idx === 0"
          >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="3">
          <form-item
            name="itemAction"
            label="Action"
            :hasLabel="idx === 0"
          >
            <el-button
              class="item-action-btn"
              type="primary"
              icon="el-icon-plus"
              @click="addItem(idx)"
              circle
            >
            </el-button>
            <el-button
              v-if="item.length > 1"
              class="item-action-btn"
              type="danger"
              icon="el-icon-minus"
              @click="deleteItem(idx)"
              circle
            >
            </el-button>
          </form-item>
        </el-col>
      </el-row>
    </el-form-item>
  </el-card>
</template>
<script>
import { ItemProductType, ItemServiceType } from '@/enums'
import { sum } from 'lodash'

const defItemData = {
  product_type: ItemProductType.FunNow,
  service_type: ItemServiceType.Other,
  amount: 0,
  description: ''
}

export default {
  name: 'document-item',
  props: {
    value: {
      type: Array,
      required: true
    },
    base: {
      type: String
    },
    prop: {
      type: String,
      default: 'item'
    },
    isAddDeposit: {
      type: Boolean,
      default: false
    },
    currencyCode: {
      type: String,
      default: '$'
    },
    currencyPrecision: {
      type: Number,
      default: 2
    }
  },
  data () {
    return {
      item: this.value
    }
  },
  computed: {
    itemBase () {
      return this.base + '.item'
    }
  },
  methods: {
    getTypeFilter (pt) {
      let res = []
      switch (pt) {
        case ItemProductType.FunNow:
          res = [
            ItemServiceType.PlatformServiceFee,
            ItemServiceType.Other
          ]
          break
        case ItemProductType.Manager:
          res = [
            ItemServiceType.ProcessingFee,
            ItemServiceType.SubscriptionFee,
            ItemServiceType.SystemSetupFee,
            ItemServiceType.CoverFee,
            ItemServiceType.SMSServiceFee,
            ItemServiceType.Other
          ]
          break
        case ItemProductType.Eatigo:
          res = [
            ItemServiceType.CoverFee,
            ItemServiceType.PromoCode,
            ItemServiceType.Other
          ]
          break
      }

      if (this.isAddDeposit) {
        res.push(ItemServiceType.Deposit)
      }

      return res
    },
    reset () {
      this.item.splice(0, this.item.length)
      this.addItem()
    },
    addItem (idx) {
      this.item.splice(idx + 1, 0, { ...defItemData })
    },
    deleteItem (idx) {
      this.item.splice(idx, 1)
    },
    sumAmount () {
      return sum(this.item.map(i => (typeof i.amount === 'number') ? i.amount : 0))
    },
    resetServiceType (idx) {
      this.item[idx].service_type = ItemServiceType.Other
    },
    getHiddenServiceTypes (productType) {
      return Object.entries(ItemServiceType).filter(([k, v]) => {
        return !(this.getTypeFilter(productType)).includes(v)
      }).map(([k, v]) => v)
    }
  },
  watch: {
    value: {
      handler (val) {
        this.item = val
      }
    },
    item: {
      handler (val) {
        this.$emit('change', val)
      },
      deep: true
    },
    isAddDeposit (isDeposit) {
      if (isDeposit) return

      this.item.forEach(itemData => {
        if (itemData.service_type === ItemServiceType.Deposit) {
          const serviceTypes = this.getTypeFilter(itemData.product_type)

          if (serviceTypes.length > 0) {
            itemData.service_type = serviceTypes[0]
          }
        }
      })
    }
  },
  mounted () {
    this.reset()
  }
}

</script>
